export const REFINE_CARD_VARIANTS = [
  {
    id: "emotions",
    label: "Gentle",
  },
  {
    id: "logistics",
    label: "Actionable",
  },
  {
    id: "values",
    label: "Curious",
  },
];

export const DEFAULT_REFINE_CARD_VARIANT_ID = REFINE_CARD_VARIANTS[0].id;

export const CURIOSITY_CARD_VARIANTS = [
  { id: "see", label: "Thoughtful", order: 0 },
  { id: "explore", label: "Curious", order: 1 },
  { id: "express", label: "Open", order: 2 },
];

export const CURIOSITY_AI_CONFIG_ID = "curiosity-ai-card-generation-v1";

export function getResultCardVariants(generation) {
  return generation?.aiConfigId === CURIOSITY_AI_CONFIG_ID
    ? CURIOSITY_CARD_VARIANTS
    : REFINE_CARD_VARIANTS;
}

export function buildRepeatedVariantQuestions(question) {
  return REFINE_CARD_VARIANTS.reduce(
    (questionsByVariant, variant) => ({
      ...questionsByVariant,
      [variant.id]: question,
    }),
    {}
  );
}
